@if(loading){
<div class="tw-flex tw-justify-center tw-p-8"><p-progressSpinner></p-progressSpinner></div>
} @else {
<div class="card">
  <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
    <h5 class="tw-m-0">{{hq.Id ? 'Edit HQ' : 'Add HQ'}}</h5>
    <div class="tw-flex tw-gap-2">
      <button pButton label="Cancel" class="p-button-text" [routerLink]="['/hq']"></button>
      <button pButton label="Save" icon="pi pi-check" (click)="save()" [disabled]="!hq.Name"></button>
    </div>
  </div>

  <p-tabView>
    <p-tabPanel header="Details">
      <div class="tw-grid tw-gap-4 tw-max-w-2xl">
        <div class="tw-flex tw-flex-col tw-gap-1">
          <label>Name</label>
          <input pInputText [(ngModel)]="hq.Name" placeholder="Brand name" />
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <label>Domains</label>
          <p-chips [(ngModel)]="hq.Domains" [allowDuplicate]="false" separator=","
            placeholder="brand.example.com"></p-chips>
          <small class="tw-text-gray-400">Domains that should resolve to this brand's landing page.</small>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <label>Tagline</label>
          <input pInputText [(ngModel)]="hq.Tagline" placeholder="Fresh ingredients, handmade dough..." />
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <label>Our Story</label>
          <textarea pInputTextarea [(ngModel)]="hq.Story" rows="6"
            placeholder="Tell the brand's story..."></textarea>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <label>Copyright</label>
          <input pInputText [(ngModel)]="hq.Copyright" placeholder="© 2025 Brand. All rights reserved." />
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <p-inputSwitch [(ngModel)]="hq.IsPublished"></p-inputSwitch>
          <label>Published</label>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Branches">
      <div class="tw-flex tw-flex-col tw-gap-2 tw-max-w-2xl">
        <label>Businesses belonging to this HQ</label>
        <p-multiSelect [options]="businesses" optionLabel="Name" optionValue="Id" [(ngModel)]="selectedBusinessIds"
          [filter]="true" filterBy="Name,Domains" display="chip" placeholder="Select businesses"
          class="tw-w-full"></p-multiSelect>
        <small class="tw-text-gray-400">Selected businesses will be listed on this brand's landing page.</small>
      </div>
    </p-tabPanel>

    <p-tabPanel header="UI Settings">
      <brt-ui-settings id="ui" [(ngModel)]="hq.UI" [business-id]="hq.Id" [keys]="[
            'Title',
            'Logo:image',
            'Scale:select:1:1.25:1.5:2:3:4',
            'ThemeColor',
            'BackgroundImage:image'
          ]">
      </brt-ui-settings>
    </p-tabPanel>
  </p-tabView>
</div>
}
